import React from 'react'
// components
import InjuryMasterMapping from '../InjuryMasterMapping'

interface Props {
  field: string
}

const UpdateParentCase: React.FC<Props> = ({ field }) => (
  <InjuryMasterMapping
    field={field}
    withParentFields
    description="Sends these fields of this form or of its parent to the existing Injury Master incident of the record's parent. It must have been created first."
  />
)

export default UpdateParentCase
